import React from "react";
import useLocaleByLanguage from "../../../../../utils/hooks/useLocaleByLanguage";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { TbTicket } from "react-icons/tb";

interface IProps {
  exerciseName: string;
  ticketName: string;
  date: number;
}

const SingleFutureTicketDetails: React.FC<IProps> = ({ exerciseName, ticketName, date }) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();

  return (
    <div className="single-future-ticket-details">
      <h5>{exerciseName}</h5>
      <span className="single-future-ticket-details__hour">
        {format(date, "cccc", { locale: locale })}, {t("godz")}: {format(date, "HH:mm")}
      </span>
      <span className="single-future-ticket-details__name">
        <TbTicket /> {ticketName}
      </span>
    </div>
  );
};

export default SingleFutureTicketDetails;
